import { createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        root: {
            minWidth: 500,
            padding: '15px 30px',
            display: 'inline-block',
            '& form': {
                display: 'flex',
                flexGrow: 1,
                justifyContent: 'space-between',
            },
            '& form>div:last-child': {
                display: 'flex',
                alignItems: 'center',
            },
        },
        pricesContainer: {
            padding: '10px 20px',
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 5,
            marginTop: 10,
        },
        priceItemContainer: {
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 0',
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        priceItemContainerEdit: {
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
            backgroundColor: theme.palette.grey[100],
            borderRadius: 5,
        },
    })
);

export default styles;
